import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'users',
    serviceName: 'unitadmin',
    query: gql`
      query users($ids: [String]) {
        users(ids: $ids) {
          data {
            id
            lastname
            firstname
            media {
              id
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
